export enum ModalKeys {
  GIGA = "giga",
  AGREEMENTS = "agreements",
  EERO = "eero",
  VAS = "vas",
  COMMERCIAL_CC = "commercial_cc",
  RESUME = "resume",
  YTV = "ytv",
  FROZEN_CREDIT = "frozen_credit",
  FROZEN_CREDIT_RESUBMIT = "frozen_credit_resubmit",
  LIFT_CREDIT_FREEZE = "lift_credit_freeze",
  LIFT_CREDIT_FREEZE_v2 = "lift_credit_freeze_v2",
  LIFT_CREDIT_FREEZE_RESUBMIT = "lift_credit_freeze_resubmit",
  OTP_VERIFY = "otp_verify",
  EDIT_ADDRESS = "edit_address",
  EDIT_PLAN = "edit_plan",
  BACK_BALANCE = "back_balance",
  AUTOPAY_ERROR = "autopay_error",
  AUTOPAY_DISCOUNT = "autopay_discount",
  BROADBAND_CONSUMER_LABEL = "broadband_consumer_label",
  VRC_OFFER = "vrc_offer",
  RETURN_OFFER = "return_offer",
  COMPARE_PLANS = "compare_plans",
  NFLST = "nflst",
  WIFI_SECURE = "wifi_secure",
  ADD_ON_COMPATIBILITY = "add_on_compatibility",
  MODERNIZED = "modernized",
  UPSELL = "upsell",
  CONTACT_CREDIT_FAQ = "contact_credit_faq",
  PROACTIVE_CHAT = "proactive_chat",
  SIMPLIFIED = "simplified",
  SAVE_QUOTE = "save_quote",
  OFFER_DETAILS = "offer_details",
  DISCOUNT = "discount",
}

export type Modals =
  | ModalKeys.AGREEMENTS
  | ModalKeys.EERO
  | ModalKeys.VAS
  | ModalKeys.COMMERCIAL_CC
  | ModalKeys.RESUME
  | ModalKeys.YTV
  | ModalKeys.FROZEN_CREDIT
  | ModalKeys.FROZEN_CREDIT_RESUBMIT
  | ModalKeys.LIFT_CREDIT_FREEZE
  | ModalKeys.LIFT_CREDIT_FREEZE_v2
  | ModalKeys.LIFT_CREDIT_FREEZE_RESUBMIT
  | ModalKeys.OTP_VERIFY
  | ModalKeys.EDIT_ADDRESS
  | ModalKeys.EDIT_PLAN
  | ModalKeys.BACK_BALANCE
  | ModalKeys.AUTOPAY_ERROR
  | ModalKeys.AUTOPAY_DISCOUNT
  | ModalKeys.BROADBAND_CONSUMER_LABEL
  | ModalKeys.VRC_OFFER
  | ModalKeys.RETURN_OFFER
  | ModalKeys.COMPARE_PLANS
  | ModalKeys.NFLST
  | ModalKeys.WIFI_SECURE
  | ModalKeys.ADD_ON_COMPATIBILITY
  | ModalKeys.MODERNIZED
  | ModalKeys.UPSELL
  | ModalKeys.CONTACT_CREDIT_FAQ
  | ModalKeys.GIGA
  | ModalKeys.PROACTIVE_CHAT
  | ModalKeys.SIMPLIFIED
  | ModalKeys.SAVE_QUOTE
  | ModalKeys.OFFER_DETAILS
  | ModalKeys.DISCOUNT
  | undefined;
